import React from "react";

/**
 * Official BlinkShots wordmark — clean, sharp, premium.
 * "Blink" = solid cinematic white · "Shots" = solid cinematic red.
 * Subtle ambient lift only — no neon bloom, no light spill.
 */
export const Wordmark = ({ className = "", size = "md", glow = true }) => {
  const sizes = {
    xs: "text-xl",
    sm: "text-2xl",
    md: "text-3xl",
    lg: "text-5xl md:text-6xl",
    xl: "text-[clamp(3.2rem,11vw,10rem)]",
    hero: "text-[clamp(3.5rem,12vw,11rem)]",
  };

  // Very subtle ambient — premium printed/embossed feel, not neon
  const blinkStyle = glow
    ? { textShadow: "0 1px 0 rgba(0,0,0,0.4), 0 0 1px rgba(255,255,255,0.6)" }
    : {};
  const shotsStyle = glow
    ? { textShadow: "0 1px 0 rgba(0,0,0,0.5), 0 0 1px rgba(225,6,0,0.4)" }
    : {};

  return (
    <span
      data-testid="blinkshots-wordmark"
      className={`font-display font-bold leading-[0.9] tracking-tight whitespace-nowrap ${sizes[size]} ${className}`}
    >
      <span className="text-white" style={blinkStyle}>
        Blink
      </span>
      <span className="text-[#E10600]" style={shotsStyle}>
        Shots
      </span>
    </span>
  );
};

export default Wordmark;
